<template>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.5" cx="10.4993" cy="10" r="8.33333" stroke="currentColor" stroke-width="1.5"/>
        <path d="M13 10H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>